import React from "react";
import abimg from "../../images/about.jpg";
import spimg1 from "../../images/ab-shape-1.png";
import spicon from "../../images/icon/badge.svg";
import sign from "../../images/signeture.png";

const About = (props) => {
  return (
    <section className={`wpo-about-section ${props.abClass}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-12 d-flex justify-content-center">
            <div className="wpo-about-wrap">
              <div className="wpo-about-img">
                <img src={abimg} alt="" />
                <div className="wpo-ab-shape-1">
                  <img src={spimg1} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12 d-flex justify-content-center">
            <div className="wpo-about-text">
              <div className="wpo-about-icon">
                <div className="icon">
                  <img src={spicon} alt="" />
                </div>
              </div>
              <div className="wpo-about-icon-content">
                <h2>
                  Há mais de 20 anos, levando a solução para profissionais e
                  empresas no setor de recursos humanos.
                </h2>
                <h3 className="fw-light">
                  Começamos com vontade de fazer diferença no atendimento
                  prestado ao candidato e também ao contratante, queríamos um
                  processo mais humanizado, mais coerente, rápido e eficiente,
                  assim nasceu Thomas Talent RH. Os primeiros atendimentos foram
                  fantásticos, conseguimos o brilho no olhar do candidato, a
                  vontade de iniciar em novos projetos e empresas satisfeitas
                  com profissionais ou serviços demandado à nós, entendemos que
                  estávamos no caminho certo.
                </h3>
                <div className="signeture">
                  <span>
                    <img src={sign} alt="" />
                  </span>
                  <p>Katiane Thomas - Diretora de RH</p>
                </div>
                <a
                  href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
                  target="_blank"
                  rel="noreferrer"
                  className="btn theme-btn"
                >
                  Saiba mais
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
